<script lang="ts" setup>
	import {Head, usePage} from '@inertiajs/vue3';
	import {useFlashMessages} from '@/scripts/composables/use-flash-messages';
	import AppTopbar from '@/views/layouts/central/partials/topbar.vue';
	import AppFooter from '@/views/layouts/central/partials/footer.vue';
	import {Toaster} from '@/views/components/ui/toast';
	import Favicon from '@/images/ProzessWunder_Icon.png';

	// Initialize flash messages and page props
	useFlashMessages();
	const page = usePage();
</script>

<template>
	<!-- Global notifications (assumed to be registered as a shadcn UI component) -->
	<Toaster />

	<!-- Setup document head -->
	<Head>
		<link
			:href="page.props.icon ?? Favicon"
			rel="icon"
		/>
		<title>ProzessWunder</title>
	</Head>

	<!-- Main layout container -->
	<div
		class="from-background to-muted flex min-h-screen flex-col bg-linear-to-b"
	>
		<header class="bg-background sticky top-0 z-40 shadow-sm">
			<AppTopbar />
		</header>

		<main class="flex-1 pt-32 pb-12">
			<slot />
		</main>

		<footer class="border-border bg-muted text-muted-foreground border-t">
			<AppFooter />
		</footer>

		<!-- Cookie Consent Components -->
		<CookieConsentBanner />
		<CookieSettingsModal />
	</div>
</template>
